import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import staticData from "../assests/staticData.json";

import ServiceList from "../components/Common/ServiceList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
export default function LifeAssistance() {
  const { life_assistance_service } = staticData;

  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={life_assistance_service.service_title}
      />
      <section className="services-layout-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={9}>
              <div className="service-detail-wrapper">
                <img
                  src={require(`../assests/${life_assistance_service.service_image}`)}
                  alt={life_assistance_service.service_title}
                  className="mb-5 img-fluid w-100 rounded-5"
                />
                <h1>{life_assistance_service.service_title}</h1>
                {life_assistance_service.service_desc.map((desc, index) => (
                  <p key={index} className="themeGrayPara in-fs lh-28">
                    {desc}
                  </p>
                ))}
                {life_assistance_service.service_desc_list.map(
                  (list, index) => (
                    <>
                      <div className="service-desc-list-box">
                        <div className="service-desc-icon">
                          <span>
                            <FontAwesomeIcon icon={faCheck} />
                          </span>
                        </div>
                        <div>
                          <p
                            key={index}
                            className="themeGrayPara in-fs lh-28 mb-2"
                          >
                            <b style={{color:"#0b3d2c"}}>{list?.title}</b>: {list?.title_desc}
                          </p>
                        </div>
                      </div>
                    </>
                  )
                )}
                {life_assistance_service.service_desc_bottom.map((desc, index) => (
                  <p key={index} className="themeGrayPara in-fs lh-28">
                    {desc}
                  </p>
                ))}
              </div>

            </CCol>
            <CCol lg={3}>
              <div className="service-list-wrapper">
                <ServiceList />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
